/* Origin theme interactions — vanilla port of the headless React behaviors. */
(function () {
  "use strict";
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const money = (c) => "£" + (Number(c) / 100).toFixed(2);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  /* Session-scoped selection memory: the flavour "buttons" are links between five
     product pages, so size / purchase-type / frequency carry over via sessionStorage. */
  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
  };
  const lockScroll = (on) => { document.body.style.overflow = on ? "hidden" : ""; };

  /* ── Header scroll + hero theming ─────────────────────────────────────── */
  const header = $("[data-header]");
  let heroTheme = "light";
  function applyHeader() {
    if (!header) return;
    const scrolled = window.scrollY > 61;
    const hasHero = header.hasAttribute("data-has-hero");
    const solid = !hasHero || scrolled || heroTheme === "light";
    header.classList.toggle("bg-ivory/90", solid);
    header.classList.toggle("backdrop-blur-md", solid);
    header.classList.toggle("bg-transparent", !solid);
    const mobile = $("[data-header-mobile]");
    if (mobile) {
      mobile.classList.toggle("text-ivory", heroTheme === "dark");
      mobile.classList.toggle("text-chocolate", heroTheme !== "dark");
    }
    const logo = $("[data-header-logo]");
    if (logo) {
      const light = window.ORIGIN_LOGO_LIGHT, dark = window.ORIGIN_LOGO_DARK;
      if (light && dark) logo.src = heroTheme === "dark" ? light : dark;
    }
  }
  window.addEventListener("scroll", applyHeader, { passive: true });

  /* ── Hero carousel ────────────────────────────────────────────────────── */
  const hero = $("[data-hero]");
  if (hero) {
    const slides = $$("[data-hero-slide]", hero);
    let idx = slides.findIndex((s) => s.classList.contains("opacity-100"));
    if (idx < 0) idx = 0;
    const arrows = $$("[data-hero-arrow]", hero);
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach((s, k) => {
        s.classList.toggle("opacity-100", k === idx);
        s.classList.toggle("opacity-0", k !== idx);
      });
      heroTheme = slides[idx].getAttribute("data-theme") || "light";
      const dark = heroTheme === "dark";
      arrows.forEach((a) => {
        a.classList.toggle("bg-sand", !dark);
        a.classList.toggle("hover:bg-sand/80", !dark);
        a.classList.toggle("bg-chocolate/80", dark);
        a.classList.toggle("hover:bg-chocolate", dark);
        const svg = $("svg", a);
        if (svg) { svg.classList.toggle("text-chocolate", !dark); svg.classList.toggle("text-ivory", dark); }
      });
      applyHeader();
    }
    const prev = $("[data-hero-prev]", hero), next = $("[data-hero-next]", hero);
    if (prev) prev.addEventListener("click", () => show(idx - 1));
    if (next) next.addEventListener("click", () => show(idx + 1));
    heroTheme = (slides[idx] && slides[idx].getAttribute("data-theme")) || "light";
  }
  applyHeader();

  /* ── Top banner rotation ──────────────────────────────────────────────── */
  const banner = $("[data-top-banner]");
  if (banner) {
    const msgs = $$("[data-banner-msg]", banner);
    if (msgs.length > 1) {
      let b = 0;
      setInterval(() => {
        b = (b + 1) % msgs.length;
        msgs.forEach((m, k) => { m.classList.toggle("opacity-100", k === b); m.classList.toggle("opacity-0", k !== b); });
      }, 5000);
    }
  }

  /* ── Word swap ("Meet the … Bar") ─────────────────────────────────────── */
  $$("[data-word-swap]").forEach((swap) => {
    const words = $$("[data-word]", swap);
    if (words.length < 2) return;
    words.forEach((w, k) => { w.style.transition = "opacity 300ms ease-out"; w.style.opacity = k === 0 ? "1" : "0"; });
    let w = 0;
    setInterval(() => {
      const prevW = w; w = (w + 1) % words.length;
      words[prevW].style.transition = "opacity 300ms ease-out"; words[prevW].style.opacity = "0";
      words[w].style.transition = "opacity 400ms ease-in 300ms"; words[w].style.opacity = "1";
    }, 3000);
  });

  /* ── Horizontal sliders (flavours, reels) ─────────────────────────────── */
  function bindSlider(btn, dir) {
    const parent = btn.parentElement;
    const slider = parent && parent.querySelector("[data-slider]");
    if (!slider) return;
    btn.addEventListener("click", () => {
      const amt = Number(slider.getAttribute("data-scroll")) || 320;
      slider.scrollBy({ left: dir === "next" ? amt : -amt, behavior: "smooth" });
    });
  }
  $$("[data-slider-prev]").forEach((b) => bindSlider(b, "prev"));
  $$("[data-slider-next]").forEach((b) => bindSlider(b, "next"));

  /* ── Reels: on-site modal (video) / lightbox (image) — never leaves the site ── */
  function openMediaModal(kind, src) {
    const overlay = document.createElement("div");
    overlay.className = "fixed inset-0 z-[80] bg-black/90 flex items-center justify-center";
    const inner = document.createElement("div");
    inner.className = "relative";
    let media;
    if (kind === "video") {
      media = document.createElement("video");
      media.src = src; media.controls = true; media.autoplay = true; media.playsInline = true; media.setAttribute("playsinline", "");
      media.className = "max-h-[85vh] max-w-[92vw] rounded-[8px]";
    } else {
      media = document.createElement("img");
      media.src = src; media.alt = "";
      media.className = "max-h-[85vh] max-w-[92vw] rounded-[8px] object-contain";
    }
    const close = document.createElement("button");
    close.className = "absolute top-3 right-3 z-20 size-9 bg-white rounded-full flex items-center justify-center";
    close.setAttribute("aria-label", "Close");
    close.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="black"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>';
    inner.appendChild(media); inner.appendChild(close); overlay.appendChild(inner);
    function remove() { overlay.remove(); document.body.style.overflow = ""; document.removeEventListener("keydown", onKey); }
    function onKey(e) { if (e.key === "Escape") remove(); }
    overlay.addEventListener("click", (e) => { if (e.target === overlay) remove(); });
    inner.addEventListener("click", (e) => e.stopPropagation());
    close.addEventListener("click", remove);
    document.addEventListener("keydown", onKey);
    document.body.appendChild(overlay); document.body.style.overflow = "hidden";
  }
  $$("[data-reel]").forEach((reel) => {
    reel.addEventListener("click", (e) => {
      if (e.target.closest("[data-reel-link]")) return; // the avatar/username link opens the profile
      const video = reel.getAttribute("data-video");
      const thumb = reel.getAttribute("data-thumb");
      if (video) openMediaModal("video", video);
      else if (thumb) openMediaModal("image", thumb);
    });
  });

  /* ── Parallax ─────────────────────────────────────────────────────────── */
  $$("[data-parallax]").forEach((sec) => {
    const layer = $("[data-parallax-layer]", sec);
    if (!layer) return;
    const speed = Number(sec.getAttribute("data-speed")) || 0.3;
    function onScroll() {
      if (window.innerWidth < 768) { layer.style.transform = ""; return; }
      const rect = sec.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        layer.style.transform = "translateY(" + (rect.top * speed) + "px)";
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
  });

  /* ── Click-to-play videos ─────────────────────────────────────────────── */
  $$("[data-video-play]").forEach((box) => {
    function play() {
      const src = box.getAttribute("data-src");
      if (!src) return;
      box.removeEventListener("click", play); // only swap in the player once
      box.removeEventListener("keydown", onKey);
      const v = document.createElement("video");
      v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true; v.setAttribute("playsinline", "");
      const poster = box.getAttribute("data-poster");
      if (poster) v.poster = poster;
      v.className = "w-full block";
      box.innerHTML = "";
      box.appendChild(v);
      box.classList.remove("cursor-pointer", "group");
    }
    function onKey(e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); play(); } }
    box.addEventListener("click", play);
    box.addEventListener("keydown", onKey);
  });

  /* ── Mobile menu ──────────────────────────────────────────────────────── */
  const menu = $("[data-mobile-menu]");
  if (menu) {
    const open = () => { menu.classList.remove("translate-x-full"); menu.classList.add("translate-x-0"); lockScroll(true); };
    const close = () => { menu.classList.add("translate-x-full"); menu.classList.remove("translate-x-0"); lockScroll(false); };
    $$("[data-menu-open]").forEach((b) => b.addEventListener("click", open));
    $$("[data-menu-close]").forEach((b) => b.addEventListener("click", () => { if (b.tagName === "A") return; close(); }));
    $$('[data-mobile-menu] a[data-menu-close]').forEach((a) => a.addEventListener("click", close));
  }

  /* ── Waitlist dialog ──────────────────────────────────────────────────── */
  const waitlist = $("[data-waitlist]");
  if (waitlist) {
    const open = () => { waitlist.classList.remove("hidden"); waitlist.classList.add("flex"); lockScroll(true); };
    const close = () => { waitlist.classList.add("hidden"); waitlist.classList.remove("flex"); lockScroll(false); try { sessionStorage.setItem("waitlist_dismissed", "1"); } catch (e) {} };
    $$("[data-waitlist-open]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); open(); }));
    waitlist.querySelectorAll("[data-waitlist-close]").forEach((b) => b.addEventListener("click", close));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !waitlist.classList.contains("hidden")) close(); });
    let dismissed = false;
    try { dismissed = !!sessionStorage.getItem("waitlist_dismissed"); } catch (e) {}
    const posted = waitlist.querySelector("[data-waitlist-posted]");
    if (!dismissed) setTimeout(open, 4000);
    if (posted) open();
  }

  /* ── Newsletter signup → Resend endpoint (footer + waitlist) ──────────── */
  $$("[data-signup-form]").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const endpoint = form.getAttribute("data-endpoint");
      const emailEl = form.querySelector('input[name="email"]');
      const nameEl = form.querySelector('input[name="name"]');
      const submit = form.querySelector("[data-signup-submit]");
      const errEl = form.querySelector("[data-signup-error]");
      const successEl = form.querySelector("[data-signup-success]");
      const fieldsEl = form.querySelector("[data-signup-fields]");
      const email = emailEl && emailEl.value;
      if (!endpoint || !email) return;
      if (errEl) errEl.classList.add("hidden");
      if (submit) { submit.disabled = true; submit.textContent = "Joining..."; }
      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email, name: (nameEl && nameEl.value) || undefined }),
        });
        if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.error || "Something went wrong"); }
        if (fieldsEl) fieldsEl.classList.add("hidden");
        if (successEl) successEl.classList.remove("hidden");
      } catch (err) {
        if (errEl) { errEl.textContent = err.message; errEl.classList.remove("hidden"); }
        if (submit) { submit.disabled = false; submit.textContent = "Join"; }
      }
    });
  });

  /* ── Basket drawer (native AJAX cart) ─────────────────────────────────── */
  const panel = $("[data-basket-panel]");
  const backdrop = $("[data-basket-backdrop]");
  function openBasket() {
    if (!panel) return;
    panel.classList.remove("translate-x-full"); panel.classList.add("translate-x-0");
    if (backdrop) { backdrop.classList.remove("opacity-0", "pointer-events-none"); backdrop.classList.add("opacity-100", "pointer-events-auto"); }
    lockScroll(true);
  }
  function closeBasket() {
    if (!panel) return;
    panel.classList.add("translate-x-full"); panel.classList.remove("translate-x-0");
    if (backdrop) { backdrop.classList.add("opacity-0", "pointer-events-none"); backdrop.classList.remove("opacity-100", "pointer-events-auto"); }
    lockScroll(false);
  }
  $$("[data-basket-open]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); openBasket(); }));
  $$("[data-basket-close]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); closeBasket(); }));
  if (backdrop) backdrop.addEventListener("click", closeBasket);

  function lineHTML(item) {
    let planName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : "One-time purchase";
    if (item.variant_title && item.variant_title !== "Default Title") planName = item.variant_title + " — " + planName;
    planName = esc(planName);
    /* Prefer the shop-grid packshot for the beige tile (map set in basket-drawer.liquid). */
    const art = (window.ORIGIN_CART_ART || {})[item.handle];
    const imgSrc = art ? art + "&width=144" : item.image;
    const img = imgSrc ? '<img src="' + imgSrc + '" alt="" class="w-full h-full object-contain p-1" loading="lazy">' : "";
    return '' +
      '<div data-basket-item data-key="' + item.key + '" class="flex gap-4 py-5 border-b border-chocolate/10">' +
        '<a href="' + item.url + '" class="block w-[72px] h-[72px] shrink-0 bg-[#F3E9D5] overflow-hidden">' + img + '</a>' +
        '<div class="flex-1 min-w-0">' +
          '<div class="flex items-start justify-between gap-2">' +
            '<a href="' + item.url + '" class="font-display text-chocolate text-[15px] leading-[1.1] tracking-wider hover:opacity-70 transition-opacity">' + (item.product_title || item.title) + '</a>' +
            '<button data-basket-remove="' + item.key + '" class="text-chocolate/40 hover:text-chocolate transition-colors shrink-0" aria-label="Remove"><svg width="14" height="14" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="1" y1="1" x2="17" y2="17"></line><line x1="17" y1="1" x2="1" y2="17"></line></svg></button>' +
          '</div>' +
          '<p class="font-serif text-chocolate/50 text-[12px] mt-0.5">' + planName + '</p>' +
          '<div class="flex items-center justify-between mt-2">' +
            '<div class="flex items-center border border-chocolate/30 bg-ivory">' +
              '<button data-basket-dec="' + item.key + '" class="w-8 h-8 flex items-center justify-center text-chocolate hover:bg-chocolate/5 transition-colors" aria-label="Decrease"><svg width="10" height="2" viewBox="0 0 12 2" fill="none"><line x1="0" y1="1" x2="12" y2="1" stroke="currentColor" stroke-width="1.5"></line></svg></button>' +
              '<span class="w-8 text-center font-serif text-chocolate text-[14px]">' + item.quantity + '</span>' +
              '<button data-basket-inc="' + item.key + '" class="w-8 h-8 flex items-center justify-center text-chocolate hover:bg-chocolate/5 transition-colors" aria-label="Increase"><svg width="10" height="10" viewBox="0 0 12 12" fill="none"><line x1="6" y1="0" x2="6" y2="12" stroke="currentColor" stroke-width="1.5"></line><line x1="0" y1="6" x2="12" y2="6" stroke="currentColor" stroke-width="1.5"></line></svg></button>' +
            '</div>' +
            '<span class="font-serif text-chocolate text-[15px]">' + money(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    $$("[data-basket-count]").forEach((el) => { el.textContent = cart.item_count; el.classList.toggle("hidden", cart.item_count === 0); });
    const ct = $("[data-basket-count-text]"); if (ct) ct.textContent = cart.item_count;
    const sub = $("[data-basket-subtotal]"); if (sub) sub.textContent = money(cart.total_price);
    const empty = $("[data-basket-empty]"), filled = $("[data-basket-filled]");
    if (empty && filled) {
      const has = cart.item_count > 0;
      empty.classList.toggle("hidden", has); empty.classList.toggle("flex", !has);
      filled.classList.toggle("hidden", !has); filled.classList.toggle("flex", has);
    }
    const list = $("[data-basket-items]");
    if (list) list.innerHTML = cart.items.map(lineHTML).join("");
    $$("[data-basket-checkout]").forEach((b) => { b.disabled = cart.item_count === 0; });
    const nudge = $("[data-basket-nudge]");
    if (nudge) {
      const thr = (window.ORIGIN_FREE_SHIP || 80);
      const subtotal = cart.total_price / 100;
      nudge.classList.toggle("hidden", cart.item_count === 0);
      nudge.textContent = subtotal >= thr ? "Your order qualifies for free shipping" : ("Spend £" + (thr - subtotal).toFixed(2) + " more for free shipping");
    }
  }
  function refreshCart(open) {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then((r) => r.json()).then((c) => { renderCart(c); if (open) openBasket(); }).catch(() => {});
  }
  function changeLine(key, qty) {
    return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then((r) => r.json()).then(renderCart).catch(() => {});
  }
  document.addEventListener("click", (e) => {
    const inc = e.target.closest("[data-basket-inc]"); const dec = e.target.closest("[data-basket-dec]"); const rm = e.target.closest("[data-basket-remove]");
    const row = e.target.closest("[data-basket-item]");
    if (!row) return;
    const qtySpan = row.querySelector(".w-8.text-center"); const cur = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
    if (inc) { e.preventDefault(); changeLine(row.getAttribute("data-key"), cur + 1); }
    else if (dec) { e.preventDefault(); changeLine(row.getAttribute("data-key"), Math.max(0, cur - 1)); }
    else if (rm) { e.preventDefault(); changeLine(row.getAttribute("data-key"), 0); }
  });

  /* ── Add to cart (PDP / quick add) ────────────────────────────────────── */
  $$("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      const body = { id: fd.get("id"), quantity: Number(fd.get("quantity") || 1) };
      const sp = fd.get("selling_plan"); if (sp) body.selling_plan = sp;
      const btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
        .then((r) => { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(() => refreshCart(true)).catch(() => {})
        .finally(() => { if (btn) btn.disabled = form.hasAttribute("data-sold-out"); });
    });
  });

  /* ── PDP: accordions ──────────────────────────────────────────────────── */
  $$("[data-accordion-toggle]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const key = btn.getAttribute("data-accordion-toggle");
      const panel = $('[data-accordion-panel="' + key + '"]');
      const icon = $("svg", btn);
      const openNow = panel.classList.contains("grid-rows-[1fr]");
      panel.classList.toggle("grid-rows-[1fr]", !openNow);
      panel.classList.toggle("grid-rows-[0fr]", openNow);
      if (icon) icon.classList.toggle("rotate-45", !openNow);
      btn.setAttribute("aria-expanded", String(!openNow));
    });
  });

  /* ── PDP: quantity stepper ────────────────────────────────────────────── */
  $$("[data-qty]").forEach((box) => {
    const val = $("[data-qty-value]", box); const input = $("[data-qty-input]", box);
    const set = (n) => { n = Math.max(1, n); if (val) val.textContent = n; if (input) input.value = n; };
    const dec = $("[data-qty-dec]", box); const inc = $("[data-qty-inc]", box);
    if (dec) dec.addEventListener("click", () => set(parseInt(val.textContent, 10) - 1));
    if (inc) inc.addEventListener("click", () => set(parseInt(val.textContent, 10) + 1));
  });

  /* ── PDP: purchase type (subscribe vs one-time) ───────────────────────── */
  const ptWrap = $("[data-purchase-types]");
  if (ptWrap) {
    const opts = $$("[data-purchase-type]", ptWrap);
    const planInput = $("[data-selling-plan-input]");
    const planSelect = $("[data-selling-plan-select]");
    const priceEl = $("[data-add-price]");
    const perBarEl = $("[data-per-bar]");
    function selectType(type) {
      opts.forEach((o) => {
        const isSub = o.getAttribute("data-purchase-type") === "subscription";
        const on = o.getAttribute("data-purchase-type") === type;
        o.setAttribute("data-selected", on ? "true" : "false");
        o.classList.toggle("border-[#C07026]", on);
        o.classList.toggle("border-chocolate/10", !on);
        if (isSub) {
          const header = o.querySelector(".flex.items-center.justify-between");
          if (header) header.classList.toggle("bg-[#F3E9D5]", on);
          const detail = o.querySelector("[data-sub-detail]"); if (detail) detail.classList.toggle("hidden", !on);
        } else {
          o.classList.toggle("bg-[#F3E9D5]", on);
        }
        const radio = o.querySelector("[data-radio]");
        if (radio) {
          radio.classList.toggle("border-[#C07026]", on);
          radio.classList.toggle("bg-[#C07026]", on);
          radio.classList.toggle("border-chocolate/30", !on);
        }
        const chk = o.querySelector("[data-radio-check]"); if (chk) chk.classList.toggle("hidden", !on);
      });
      if (planInput) planInput.value = type === "subscription" && planSelect ? planSelect.value : "";
      const onePrice = ptWrap.getAttribute("data-one-price");
      const subPrice = planSelect ? (planSelect.selectedOptions[0] && planSelect.selectedOptions[0].getAttribute("data-price")) : ptWrap.getAttribute("data-sub-price");
      if (priceEl) priceEl.textContent = "— " + (type === "subscription" && subPrice ? subPrice : onePrice);
      if (perBarEl) {
        const onePb = ptWrap.getAttribute("data-one-per-bar");
        const subPb = planSelect ? (planSelect.selectedOptions[0] && planSelect.selectedOptions[0].getAttribute("data-per-bar")) : ptWrap.getAttribute("data-sub-per-bar");
        perBarEl.textContent = (type === "subscription" && subPb ? subPb : onePb);
      }
      store.set("origin:ptype", type);
      if (type === "subscription" && planSelect) store.set("origin:plan", planSelect.value);
    }
    opts.forEach((o) => o.addEventListener("click", () => selectType(o.getAttribute("data-purchase-type"))));
    if (planSelect) planSelect.addEventListener("change", () => { if (planInput) planInput.value = planSelect.value; store.set("origin:plan", planSelect.value); selectType("subscription"); });
    const initial = ptWrap.getAttribute("data-initial") || "one-time";
    /* Read saved selections BEFORE any restore runs — applyVariant/selectType
       write back to the store and would clobber them. */
    const savedType = store.get("origin:ptype");
    const savedPlanId = store.get("origin:plan");
    const savedSize = store.get("origin:size");

    /* ── PDP: size (variant) picker ─────────────────────────────────────── */
    const sizeWrap = $("[data-size-options]");
    const vDataEl = $("[data-variant-data]");
    if (sizeWrap && vDataEl) {
      let vdata = {};
      try { vdata = JSON.parse(vDataEl.textContent); } catch (e) { vdata = {}; }
      const sizeBtns = $$("[data-size-btn]", sizeWrap);
      const form = $("[data-product-form]");
      const idInput = form && form.querySelector('input[name="id"]');
      const submitBtn = form && form.querySelector('[type="submit"]');
      const addLabel = $("[data-add-label]");
      const stockNote = $("[data-stock-note]");
      const oneTimePriceEl = $("[data-one-time-price]");
      const subOpt = $('[data-purchase-type="subscription"]', ptWrap);
      const subCompare = $("[data-sub-compare]");
      const subPriceEl = $("[data-sub-price-el]");
      function applyVariant(id) {
        const v = vdata[id];
        if (!v) return;
        sizeBtns.forEach((b) => {
          const on = b.getAttribute("data-variant-id") === String(id);
          b.classList.toggle("border-[#C07026]", on);
          b.classList.toggle("bg-[#F3E9D5]", on);
          b.classList.toggle("text-chocolate", on);
          b.classList.toggle("border-chocolate/20", !on);
          b.classList.toggle("text-chocolate/60", !on);
          b.classList.toggle("hover:border-chocolate/40", !on);
          b.classList.toggle("hover:text-chocolate", !on);
          const chk = b.querySelector("[data-size-check]"); if (chk) chk.classList.toggle("hidden", !on);
        });
        if (idInput) idInput.value = id;
        ptWrap.setAttribute("data-one-price", v.priceMoney);
        if (v.bars) ptWrap.setAttribute("data-one-per-bar", money(v.priceC / v.bars));
        if (oneTimePriceEl) oneTimePriceEl.textContent = v.priceMoney;
        if (subOpt) {
          subOpt.classList.toggle("hidden", !v.offerSub);
          if (v.offerSub) {
            if (subCompare) subCompare.textContent = v.priceMoney;
            if (planSelect) {
              $$("option", planSelect).forEach((opt) => {
                const p = v.plans && v.plans[opt.value];
                if (p) { opt.setAttribute("data-price", p.m); if (v.bars) opt.setAttribute("data-per-bar", money(p.c / v.bars)); }
              });
              const cur = planSelect.selectedOptions[0];
              if (cur) {
                if (subPriceEl) subPriceEl.textContent = cur.getAttribute("data-price");
                ptWrap.setAttribute("data-sub-price", cur.getAttribute("data-price"));
                ptWrap.setAttribute("data-sub-per-bar", cur.getAttribute("data-per-bar") || "");
              }
            }
          }
          const subSelected = subOpt.getAttribute("data-selected") === "true";
          selectType(subSelected && v.offerSub ? "subscription" : "one-time");
        } else {
          selectType("one-time");
        }
        store.set("origin:size", v.title);
        if (form) form.toggleAttribute("data-sold-out", !v.available);
        if (submitBtn) submitBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? "Add to Bag" : "Sold Out";
        if (stockNote) {
          stockNote.textContent = v.available ? "In stock and ready to ship." : "Currently out of stock.";
          stockNote.classList.toggle("text-chocolate/50", v.available);
          stockNote.classList.toggle("text-[#C07026]", !v.available);
        }
        try {
          const u = new URL(window.location.href);
          u.searchParams.set("variant", id);
          window.history.replaceState({}, "", u);
        } catch (e) {}
      }
      sizeBtns.forEach((b) => b.addEventListener("click", () => applyVariant(b.getAttribute("data-variant-id"))));

      /* Restore the size chosen on a previous flavour page (this session);
         skip when it is sold out here — the product's default wins. */
      if (savedSize && idInput) {
        const target = sizeBtns.find((b) => b.getAttribute("data-size-title") === savedSize);
        if (target) {
          const tid = target.getAttribute("data-variant-id");
          const tv = vdata[tid];
          if (tv && tv.available && tid !== String(idInput.value)) applyVariant(tid);
        }
      }
    }

    /* Restore purchase type + delivery frequency across flavour pages; fall back
       to this product's default when the saved choice is not offered here. */
    if (savedPlanId && planSelect) {
      const opt = Array.from(planSelect.options).find((o) => o.value === savedPlanId);
      if (opt) { planSelect.value = savedPlanId; if (planInput) planInput.value = savedPlanId; }
    }
    let want = savedType || initial;
    if (want === "subscription") {
      const subEl = $('[data-purchase-type="subscription"]', ptWrap);
      if (!subEl || subEl.classList.contains("hidden")) want = "one-time";
    }
    selectType(want);
  }

  /* ── PDP: image gallery thumbnails ────────────────────────────────────── */
  const gallery = $("[data-pdp-gallery]");
  if (gallery) {
    const main = $("[data-pdp-main]", gallery);
    $$("[data-pdp-thumb]", gallery).forEach((t) => {
      t.addEventListener("click", () => {
        const src = t.getAttribute("data-src");
        /* the main img carries srcset/sizes for the LCP load — they'd override a bare
           src swap, so drop them when the user picks a thumbnail */
        if (main && src) { main.removeAttribute("srcset"); main.removeAttribute("sizes"); main.src = src; }
        $$("[data-pdp-thumb]", gallery).forEach((x) => { x.classList.remove("border-chocolate"); x.classList.add("border-transparent"); });
        t.classList.remove("border-transparent"); t.classList.add("border-chocolate");
      });
    });
  }

  /* ── PDP: mobile swipe carousel dots ──────────────────────────────────── */
  const mStrip = $("[data-pdp-mobile]");
  const mDots = $("[data-pdp-dots]");
  if (mStrip && mDots) {
    const dots = $$("button", mDots);
    const setActive = (i) => dots.forEach((d, j) => {
      d.classList.toggle("bg-chocolate", j === i);
      d.classList.toggle("bg-chocolate/30", j !== i);
    });
    mStrip.addEventListener("scroll", () => {
      setActive(Math.round(mStrip.scrollLeft / mStrip.clientWidth));
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener("click", () => {
      mStrip.scrollTo({ left: i * mStrip.clientWidth, behavior: "smooth" });
    }));
  }

  /* ── Slow-motion videos (data-playback) — re-assert on ratechange so the
        browser's autoplay reset doesn't beat the deferred JS ────────────── */
  $$("video[data-playback]").forEach((v) => {
    const rate = parseFloat(v.getAttribute("data-playback")) || 1;
    const apply = () => { if (v.playbackRate !== rate) v.playbackRate = rate; };
    ["loadedmetadata", "loadeddata", "canplay", "play", "playing", "ratechange"].forEach((ev) => v.addEventListener(ev, apply));
    apply();
  });
})();
